import * as actionTypes from './actionTypes';

const initialState = {
  jwToken: {},
  error: { loginError: false, message: '' },
  user: {},
  staff: {}
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_STAFF_LOGIN_SUCCESS:
      return { ...state, jwToken: action.login.jwToken, user: action.login.user };
    case actionTypes.FETCH_STAFF_LOGIN_FAILURE:
      return { ...state, error: { loginError: true, message: action.message } };
    case actionTypes.FETCH_SUCCESS:
      return { ...state, staff: action };
    case actionTypes.FETCH_FAILURE:
      return { ...state, error: { message: action.message } };
    default:
      return state;
  }
};

export { reducer as default };
